<ng-template #buttons>
    <button #nextBtn
            type="button"
            [disabled]="isDisabled()"
            class="btn btn-block btn-primary btn-lg"
            (click)="updateProfile()">
        <div class="circle-loader"></div>
        <span>{{ 'next' | localise }} <i class="fa fa-arrow-circle-right"></i></span>
    </button>
    <button
        #prevBtn
        type="button"
        *ngIf="isPrevBtnVisible()"
        class="btn btn-block btn-outline-secondary btn-lg"
        (click)="prevSlide()">
        <span><i class="fa fa-arrow-circle-left"></i> {{ 'back' | localise }}</span>
    </button>
</ng-template>

<ng-container>
    <div class="row">
        <div id="wizard" class="col-md-12 col-xl-12">
            <app-swiper
                    [class]="'wizard-swiper'"
                    [config]="customSwiperConfig"
                    [slideIndex]="activeSlideIndex">
                <div [class.form-group]="!(firstName.dirty && !firstName.valid)"
                     class="step col-md-12 d-flex flex-column justify-content-center">
                    <input
                            (keyup.enter)="updateProfile()"
                            type="text"
                            class="form-control"
                            [placeholder]="'enter_first_name' | localise"
                            [formControl]="firstName"
                            [inputValidation]="{
          condition: firstName.dirty && !firstName.valid,
          error: 'enter_first_name' | localise
        }"
                    />

                    <div class="save-button-wrapper">
                        <ng-template [ngTemplateOutlet]="buttons"></ng-template>
                    </div>
                </div>
                <div [class.form-group]="!(surname.dirty && !surname.valid)"
                     class="step col-md-12 d-flex flex-column justify-content-center">
                    <input
                            (keyup.enter)="updateProfile()"
                            type="text"
                            class="form-control"
                            [placeholder]="'enter_surname' | localise"
                            [formControl]="surname"
                            [inputValidation]="{
          condition: surname.dirty && !surname.valid,
          error: 'enter_surname' | localise
        }"
                    />
                    <div class="save-button-wrapper">
                        <ng-template [ngTemplateOutlet]="buttons"></ng-template>
                    </div>
                </div>
                <div class="form-group step col-md-12 d-flex flex-column justify-content-center">
                    <label>{{ 'age' | localise }}</label>
                    <input
                            (keyup.enter)="updateProfile()"
                            type="number"
                            step="1"
                            min="18"
                            max="100"
                            class="form-control"
                            [placeholder]="'enter_age' | localise"
                            [formControl]="age"/>
                    <div class="save-button-wrapper">
                        <ng-template [ngTemplateOutlet]="buttons"></ng-template>
                    </div>
                </div>
                <div class="form-group step col-md-12 d-flex flex-column justify-content-center">
                    <label>{{ 'global_profile' | localise }}</label>
                    <app-options-list
                            [options]="globalProfiles"
                            [selected]="[currentlyGlobalProfile]"
                            bindProperty="name"
                            bindTextProperty="text"
                            optionType="radio"
                            (optionSelected)="currentlyGlobalProfile = $event"
                    ></app-options-list>
                    <div class="save-button-wrapper">
                        <ng-template [ngTemplateOutlet]="buttons"></ng-template>
                    </div>
                </div>
                <div class="form-group step col-md-12 d-flex flex-column justify-content-center">
                    <label>{{ 'gender' | localise }}</label>
                    <div class="form-check" style="padding: 0 9px;" (click)="onGenderSelected('M')">
                        <label class="form-check-label" style="width: 100%; padding: 14px 4px;">
                            <input
                                    type="radio"
                                    class="form-check-input"
                                    name="optionsRadios"
                                    (input)="onGenderSelected('M')"
                                    [checked]="currentlySelectedGender?.gender === 'M'"
                            />
                            {{ 'male' | localise }}
                            <i class="input-helper"></i>
                        </label>
                    </div>
                    <div class="form-check" style="padding: 0 9px;" (click)="onGenderSelected('F')">
                        <label class="form-check-label" style="width: 100%; padding: 14px 4px;">
                            <input
                                    type="radio"
                                    class="form-check-input"
                                    name="optionsRadios"
                                    (input)="onGenderSelected('F')"
                                    [checked]="currentlySelectedGender?.gender === 'F'"
                            />
                            {{ 'female' | localise }}
                            <i class="input-helper"></i>
                        </label>
                    </div>
                    <div class="save-button-wrapper">
                        <ng-template [ngTemplateOutlet]="buttons"></ng-template>
                    </div>
                </div>
                <div class="form-group step col-md-12 d-flex flex-column justify-content-center">
                    <label>{{ 'weight' | localise }}</label>
                    <input
                            (keyup.enter)="updateProfile()"
                            type="number"
                            step="1"
                            oninput="this.value=((parseInt(this.value)||0) > 300 ? 300 : (parseInt(this.value)||0))"
                            onkeydown="if(event.key==='.' || event.key===','){event.preventDefault();}"
                            class="form-control"
                            [placeholder]="'enter_weight' | localise"
                            [formControl]="weight"/>
                    <div class="save-button-wrapper">
                        <ng-template [ngTemplateOutlet]="buttons"></ng-template>
                    </div>
                </div>
                <div class="form-group step col-md-12 d-flex flex-column justify-content-center">
                    <label>{{ 'target_weight' | localise }}</label>
                    <input
                            (keyup.enter)="updateProfile()"
                            type="number"
                            step="1"
                            oninput="this.value=((parseInt(this.value)||0) > 300 ? 300 : (parseInt(this.value)||0))"
                            onkeydown="if(event.key==='.' || event.key===','){event.preventDefault();}"
                            class="form-control"
                            [placeholder]="'enter_weight' | localise"
                            [formControl]="target_weight"/>
                    <div class="save-button-wrapper">
                        <ng-template [ngTemplateOutlet]="buttons"></ng-template>
                    </div>
                </div>
                <div class="form-group step col-md-12 d-flex flex-column justify-content-center">
                    <label>{{ 'height' | localise }}</label>
                    <input
                            (keyup.enter)="updateProfile()"
                            type="number"
                            oninput="this.value=((parseInt(this.value)||0) > 300 ? 300 : (parseInt(this.value)||0))"
                            onkeydown="if(event.key==='.' || event.key===','){event.preventDefault();}"
                            step="1"
                            class="form-control"
                            [placeholder]="'enter_height' | localise"
                            [formControl]="height"/>
                    <div class="save-button-wrapper">
                        <ng-template [ngTemplateOutlet]="buttons"></ng-template>
                    </div>
                </div>
                <div class="form-group step col-md-12 d-flex flex-column justify-content-center">
                    <label>{{ 'fat_hold' | localise }}</label>
                    <app-options-list
                            [options]="fatHolds"
                            [selected]="[currentlyFatHold]"
                            bindProperty="name"
                            optionType="radio"
                            (optionSelected)="currentlyFatHold = $event"
                    ></app-options-list>
                    <div class="save-button-wrapper">
                        <ng-template [ngTemplateOutlet]="buttons"></ng-template>
                    </div>
                </div>
<!--                <div class="form-group step col-md-12" style="overflow-y: auto !important;">-->
<!--                    <label>{{ 'body_type' | localise }}</label>-->

<!--                    <div class="row">-->
<!--                        <div class="col-md-4 col-lg-4 col-sm-12 col-12" *ngFor="let bodyType of bodyTypes">-->
<!--                            <div class="form-check"-->
<!--                                 [ngClass]="currentlySelectedBodyType && currentlySelectedBodyType.id === bodyType.id ? 'selected-body-type' : ''"-->
<!--                            >-->
<!--                                <label class="form-check-label" style="font-size: 1.05rem;"-->
<!--                                       (click)="onSelectedBodyType(bodyType)"-->
<!--                                >-->
<!--                                    {{ bodyType.title }}-->

<!--                                    <div class="col-md-12 body-types">-->
<!--                                        <div class="body-type body-type-male-{{ bodyType.id }}"></div>-->
<!--                                        <div class="body-type body-type-female-{{ bodyType.id }}"></div>-->
<!--                                    </div>-->
<!--                                </label>-->
<!--                            </div>-->
<!--                            <div class="body-description"-->
<!--                                 [innerHTML]="getBodyTypeTranslationKey(bodyType.id) | localise | keepHtml"></div>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <div class="save-button-wrapper">-->
<!--                        <ng-template [ngTemplateOutlet]="buttons"></ng-template>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="form-group step col-md-12 d-flex flex-column justify-content-center">
                    <label>{{ 'daily_meals' | localise }}</label>
                    <app-options-list
                            [options]="dailyMeals"
                            [selected]="[currentlySelectedDailyMeal]"
                            bindProperty="title"
                            optionType="radio"
                            (optionSelected)="currentlySelectedDailyMeal = $event"
                    ></app-options-list>
                    <div class="save-button-wrapper">
                        <ng-template [ngTemplateOutlet]="buttons"></ng-template>
                    </div>
                </div>

                <div class="form-group step col-md-12 d-flex flex-column justify-content-center">
                    <label>{{ 'how_long_food_prepare' | localise }}</label>
                    <app-options-list
                            [options]="howLongFoodPrepareViewModels"
                            [selected]="[currentlyHowLongFoodPrepare]"
                            bindProperty="id"
                            translate="1"
                            optionType="radio"
                            (optionSelected)="currentlyHowLongFoodPrepare = $event"
                    ></app-options-list>
                    <div class="save-button-wrapper">
                        <ng-template [ngTemplateOutlet]="buttons"></ng-template>
                    </div>
                </div>

                <div class="form-group step col-md-12 d-flex flex-column justify-content-center">
                    <label>{{ 'when_prepare_food' | localise }}</label>
                    <app-options-list
                            [options]="whenPrepareFoods"
                            [selected]="[currentlyWhenPrepareFood]"
                            bindProperty="id"
                            translate="1"
                            optionType="radio"
                            (optionSelected)="currentlyWhenPrepareFood = $event"
                    ></app-options-list>
                    <div class="save-button-wrapper">
                        <ng-template [ngTemplateOutlet]="buttons"></ng-template>
                    </div>
                </div>

                <div class="form-group step col-md-12 d-flex flex-column justify-content-center">

                    <div class="products">

                        <ng-container>
                            <div class="category-title">
                                {{ 'user_preferred_meals' | localise }}
                            </div>

                            <div class="col-12">
                                <div class="row portfolio-grid">
                                    <ng-container *ngFor="let category of globalCategories">
                                        <div *ngIf="category.images.length > 0"
                                             (click)="addCategoryToPreferred(category)"
                                             class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 product-col">
                                            <figure class="recipe-figure">
                                                <div
                                                        (click)="addCategoryToPreferred(category)"
                                                        class="card-img-top animated fadeIn global-category-image"
                                                        [lazyLoad]="constants.imagesUrl() + '/images/300x150/' + category.images[0].type + '/' + category.images[0].name + '/'">

                                                    <div class="recipe-check"
                                                         [ngClass]="isCategoryPreferred(category) ? 'checked' : ''"
                                                         (click)="addCategoryToPreferred(category)">
                                                        <i class="fa fa-check"></i>
                                                    </div>
                                                </div>

                                                <figcaption>
                                                    <h4
                                                            class="recipe-title-influencer">{{ category.title }}</h4>
                                                </figcaption>
                                            </figure>
                                        </div>

                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>

                        <div class="products-btn-wrapper">
                            <button (click)="updateUserPreferredCategories()"
                                    [disabled]="selectedPreferredCategories.length < 2"
                                    class="btn btn-block btn-success">
                                {{ 'save' | localise }} ( {{ selectedPreferredCategories.length }} )
                            </button>
                        </div>
                    </div>

                </div>
                <div class="form-group step col-md-12 d-flex flex-column justify-content-center">
                    <div class="verification-email">
                        <i class="mdi mdi-email-open"></i>
                        <p>{{ 'verification_email_was_sent' | localise }} <strong>{{ email }}</strong></p>

<!--                        <button type="button"-->
<!--                                (click)="openEmailProviderWebsite()"-->
<!--                                class="btn btn-block btn-success">-->
<!--                            <span>{{ 'open_email_provider' | localise }}</span>-->
<!--                        </button>-->

                        <button type="button"
                                style="margin-top: 10px;"
                                (click)="sendAgain()"
                                class="btn btn-block btn-primary">
                            <span>{{ 'send_new_mail' | localise }}</span>
                        </button>
                    </div>
                </div>
            </app-swiper>
        </div>

        <!--        <div #nextBtnWrapper class="save-button-wrapper">-->
        <!--            <button #nextBtn-->
        <!--                    type="button"-->
        <!--                    [disabled]="isDisabled()"-->
        <!--                    class="btn btn-block btn-success"-->
        <!--                    (click)="updateProfile()">-->
        <!--                <div class="circle-loader"></div>-->
        <!--                <span>{{ 'next' | localise }}</span>-->
        <!--            </button>-->
        <!--        </div>-->
    </div>
</ng-container>
